import { NgModule } from '@angular/core';
import { CustomerPhotoModalComponent } from './individual-customer-photo-modal.component';
import { CustomerImageModule } from '../../image/customer-image.module';

@NgModule({
    declarations: [
        CustomerPhotoModalComponent
    ],
    providers: [
    ],
    imports: [
        CustomerImageModule
    ],
    exports: [
    ]
})

export class IndividualCustomerPhotoModule { }
